import React, { useRef } from 'react';
import * as Styled from './ATextInteractive.styles';
import { ATextInteractiveSize, type ATextInteractiveProps } from './ATextInteractive.types';
import { useTracking } from '../../hooks';
import clsx from 'clsx';

const COMPONENT_NAME = 'a-web-ui-kit-ATextInteractive';
const TEST_ID = 'web-ui-kit-ATextInteractive';

const SIZE_MAP = {
  [ATextInteractiveSize.XS]: { textClassName: 't-font-xs', linkClassName: 'm-list-link-xs' },
  [ATextInteractiveSize.S]: { textClassName: 't-font-s', linkClassName: 'm-list-link-s' },
  [ATextInteractiveSize.M]: { textClassName: 't-font-m', linkClassName: 'm-list-link-m' },
};

const ATextInteractive = React.forwardRef<HTMLElement, ATextInteractiveProps>((props, ref) => {
  const {
    text,
    size = ATextInteractiveSize.M,
    className,
    trackingProperties,
    isExternal,
    custom_click_track_value,
    preTrackVal,
    ...rest
  } = props;
  const defaultRef = useRef<HTMLElement>(null);
  const elementRef = (ref ?? defaultRef) as React.RefObject<HTMLElement>;
  const isLink = rest.href?.trim().length;

  useTracking({
    ref: elementRef,
    trackingProperties,
    isExternal,
    custom_click_track_value,
    preTrackVal,
    text,
  });

  return (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      as={isLink ? 'a' : 'span'}
      ref={elementRef}
      className={clsx(SIZE_MAP[size][isLink ? 'linkClassName' : 'textClassName'], className)}
      {...rest}
    >
      {text}
    </Styled.Wrapper>
  );
});

export { ATextInteractive, ATextInteractiveSize, TEST_ID as A_Text_INTERACTIVE_TEST_ID };
